import React from 'react'
import moment from 'moment'

import * as questionService from '../services/question-service'
import * as answerService from '../services/answer-service'
import * as scansService from '../services/scan-service'
import {getCollaboratorsResponses} from '../services/consultation-service'

import Score from './Score'
import EvacuationScore from './EvacuationScore'
import Bar from './Bar'
import IconTooltip from './IconTooltip'
import ScoreMatrix from './ScoreMatrix'
import PrintExtendedHeader from './PrintExtendedHeader'
import PrintScanScores from './PrintScanScores'
import PrintQuestionAnswers from './PrintQuestionAnswers'
import DownloadPdf from './DownloadPdf'
import PrintQuestion from './PrintQuestion'
import {buildAnswerMap} from '../utils'

import {ScanResultContext} from '../context/ScanResultContext'

export default class ScanInfo extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.state = {
      questions: {coreQuestions: [], extraQuestions: []},
      answers: [],
      originalAnswers: [],
      scan: [],
      extraQuestionResponses: []
    }
  }

  componentDidMount() {
    const setInitialState = (answers, originalAnswers, questions, scan, responses) => {
      this.setState({
        ...this.state,
        answers,
        originalAnswers,
        questions,
        scan,
        extraQuestionResponses: responses
      })
      window.sessionStorage.setItem('result', JSON.stringify(this.state))
    }

    Promise.all([
      answerService.getAnswers(this.props.scan.id),
      answerService.getAnswers(this.props.originalScan.id),
      questionService.getQuestion(1, this.props.scan.id),
      scansService.getScanById(this.props.scan.id)
    ]).then(([answers, originalAnswers, questions, scan]) => {
      if (questions.extraQuestionsEnabled) {
        Promise.all(questions.extraQuestions.map(question => {
          return getCollaboratorsResponses(this.props.scan.id, question.id)
        })).then(responses => setInitialState(answers, originalAnswers, questions, scan, responses))
      } else {
        setInitialState(answers, originalAnswers, questions, scan, [])
      }
    })
  }

  getPhaseScoreIndicator(pt, i) {
    const percRiskfulAnswers = this.state.scan.percRiskfulAnswers
    const negativeScore = pt.score < 0
    const lowPerc = percRiskfulAnswers < 0.5
    const exclamationMark = negativeScore !== lowPerc || negativeScore === lowPerc
    return (
      <div className={`phase-total ${ pt.score >= 0 ? 'positive' : 'negative' }`} key={i}>
        <Score score={pt.score} />
        <span className="phase-label">
          <span className="text">{pt.phase}</span>
          <IconTooltip id={pt.phase} icon='far fa-info-circle' />
        </span>
        {(pt.phase === "Oorzaak" && percRiskfulAnswers > 0 && exclamationMark) &&
          <span className="exclamation-mark">
          <IconTooltip warningIcon='true' text="<p>Deze alert geeft aan dat de feitelijke score op het ontstaan van brand afwijkt van de subjectieve beleving van medewerkers. Dit kan betekenen dat medewerkers de kans op brand onterecht vrij groot achten terwijl dit feitelijk niet zo is. Het kan ook betekenen dat medewerkers de kans op brand onterecht vrij klein achten terwijl dit feitelijk niet zo is (schijnveiligheid).</p>" icon='far fa-exclamation-triangle' />
        </span>}
      </div>
    )
  }

  printExtraQuestions(extraQuestions, questions, answers, originalAnswers, extraQuestionsResponses) {
    return (
      <div className="scan-container">
        {extraQuestions.map((question, i) => {
          return (
            <PrintQuestion
              key={'extravraag-' + i}
              question={question}
              state={answers}
              isIntroQuestions={true}
              answermap={buildAnswerMap(questions, answers)}
              collaborationresponse={extraQuestionsResponses[i]}
            />)
        })
        }
      </div>
    )
  }

  render() {
    const { scan, originalScan, total, matrix, phaseTotals, wheelTotals, currentUnit } = this.props
    const {answers, originalAnswers, questions, extraQuestionResponses} = this.state

    return (
      <div className="inner-container">
        <p>Scan: {scan && scan.completedDate && moment(scan.completedDate).format('DD-MM-YYYY')}</p>

        <div className="results-container row">
          <div className="col">
            <div className="block total-score">
              <h2>Totaalscore <IconTooltip
                text="<p>Dit is de totaalscore van de scan ten opzichte van de norm. Het referentie kader voor de norm is bepaald door het vaststellen van een maatgevend scenario en vervolgens te bepalen welk risico redelijkerwijs acceptabel is. Voor een toelichting hiervan, zie Account &ndash; Over BrandWijzer - Verantwoording</p>"
                icon='far fa-info-circle'/></h2>
              <Bar score={scan.totalScore}/>
              <Score score={scan.totalScore}/>
              <div className="info"><span className="info-container">Norm</span></div>
            </div>

            <div className="block">
              <h2>Score per stuurwielonderdeel <IconTooltip
                text="<p>Dit is de score per onderdeel van het Stuurwiel Risicogestuurde Brandveiligheid. Het stuurwiel toont de samenhang tussen alle risicogebieden en maatregelen. Voor een toelichting hiervan, zie Account &ndash; Over BrandWijzer - Verantwoording</p>"
                icon='far fa-info-circle'/></h2>
              {wheelTotals.map((wt, i) => <div key={i}><span className="bar-label">{wt.steeringWheel} <IconTooltip
                id={wt.steeringWheel} icon='far fa-info-circle'/></span> <Bar score={wt.score}/> <Score
                score={wt.score}/></div>)}
            </div>

            <EvacuationScore scan = { this.props.scan } />
            
            <div className="block">
              <h2>Extra vragen medewerkers</h2>
              <DownloadPdf
                text="<p>Wilt u de uitkomsten van de extra vragen aan medewerkers downloaden?</p>"
                title="Download uitkomsten extra vragen"
                textbtn="Uitkomsten (PDF)"
                type="consultations"
              />
            </div>
          </div>

          <div className="col">
            <div className="block">
              <h2>Score per fase <IconTooltip
                text="<p>Hier ziet u de scores per ontwikkelfase bij een brand, achtereenvolgens Ontstaan van brand, Brandontwikkeling en rookverspreiding, Ontruiming en Continu&#239;teit van zorg.</p>"
                icon='far fa-info-circle'/></h2>
              {phaseTotals.map((pt, i) =>
                pt.score !== null && this.getPhaseScoreIndicator(pt, i)
                // NB: met de huidige vragenlijst zou er altijd een niet null score voor elke fase moeten zijn.
                // Mocht hij toch NULL zijn dan laten we 'm nu helemaal weg.
              )}
            </div>

            <div className="block">
              <h2>Brandveiligheidsmatrix <IconTooltip
                text="<p>Ingevulde antwoorden van een scan hebben impact op een of meerdere van de stuurwielonderdelen als impact op een of meerdere ontwikkelfases. Alle antwoorden vormen zo samen een matrix. De rode of groene ballen op de snijvlakken van de matrix geven zo een eerste indruk van waar de grootste risico's of verbetermogelijkheden liggen.</p>"
                icon='far fa-info-circle'/></h2>
              <ScoreMatrix matrix={matrix}/>
            </div>
          </div>

          <ScanResultContext.Consumer>
            {ctx => {
              if (ctx.state.printPdf === true) {
                window.sessionStorage.setItem('printPdf', true)

                return (
                  <div>
                    <div className="feedback-exquestions">
                      <PrintExtendedHeader scan={scan}
                                           originalScan={originalScan}
                                           currentUnit={currentUnit}
                                           type="extraQuestions" />
                      {this.printExtraQuestions(questions.extraQuestions, questions, answers, originalAnswers, extraQuestionResponses)}
                    </div>

                    <div className="print-pdf">
                      <PrintExtendedHeader scan={scan}
                                           originalScan={originalScan}
                                           currentUnit={currentUnit}
                                           type="results" />
                      <PrintScanScores key={"print-pdf-scores"}
                                       scan={scan}
                                       total={total}
                                       wheelTotals={wheelTotals}
                                       phaseTotals={phaseTotals}
                                       type="results"/>
                      <PrintQuestionAnswers key={"print-pdf-answers"}
                                            scan={scan}
                                            originalScan={scan}
                                            originalAnswers={originalAnswers}
                                            questions={questions}
                                            type="results"/>
                    </div>
                  </div>
                )
              }
            }
            }
          </ScanResultContext.Consumer>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ScanInfo.js